import axios from 'axios'
import router from '../router'

export default {
    namespaced: true,
    state:{
        profileUpdate:false
    },
    getters:{
        profileUpdate(state){
            return state.profileUpdate
        }
    },
    mutations:{
        SET_PROFILE_UPDATE (state, value) {
            state.profileUpdate = value
        }
    },
    actions:{
        modalProfileUpdate({commit}, open){
            commit('SET_PROFILE_UPDATE', open)
        }
    }
}